<template>
  <div>
    <b-row>
      <!-- <b-col class="col-12 col-md-6">
         <b-form-group>
          <b-form-input required :title="labels.cardNumber"
            v-model="form.country" class="fix-padding" id="country"/>
          <label for="country" class="custom-input-label">{{labels.country}}</label>
        </b-form-group>
      </b-col> -->

      <b-col class="col-md-6">
        <b-form-group>
          <b-form-input
            required
            :title="labels.zipcode"
            v-model="form.zipcode"
            class="fix-padding"
            :state="validateField('zipcode')"
            masked="true"
            v-mask="'#####-###'"
            id="zipcode"
            @change="searchCEP(form.zipcode)"
          />
          <label for="zipcode" class="custom-input-label">
            {{ labels.zipcode }}
            <i class="mdi mdi-loading mdi-spin" v-if="searchingCEP"></i>
            <span>{{ cepNotFoundMessage }}</span>
          </label>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <b-form-group>
          <b-form-input
            required
            :title="labels.address"
            :state="validateField('address')"
            v-model="form.address"
            class="fix-padding"
            id="address"
          />
          <label for="address" class="custom-input-label">{{
            labels.address
          }}</label>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col class="col-md-4">
        <b-form-group>
          <b-form-input
            required
            :title="labels.number"
            :state="validateField('number')"
            v-model="form.number"
            class="fix-padding"
            type="number"
            id="number"
          />
          <label for="number" class="custom-input-label">{{
            labels.number
          }}</label>
        </b-form-group>
      </b-col>

      <b-col>
        <b-form-group>
          <b-form-input
            :title="labels.complement"
            v-model="form.complement"
            v-empty-input
            class="fix-padding"
            id="complement"
          />
          <label for="complement" class="custom-input-label">{{
            labels.complement
          }}</label>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col class="col-12 col-md-6">
        <b-form-group>
          <b-form-input
            required
            :title="labels.state"
            :state="validateField('state')"
            v-model="form.state"
            class="fix-padding"
            id="state"
          />
          <label for="state" class="custom-input-label">{{
            labels.state
          }}</label>
        </b-form-group>
      </b-col>

      <b-col class="col-md-6">
        <b-form-group>
          <b-form-input
            required
            :title="labels.city"
            :state="validateField('city')"
            v-model="form.city"
            class="fix-padding"
            id="city"
          />
          <label for="city" class="custom-input-label">{{ labels.city }}</label>
        </b-form-group>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { mask } from 'vue-the-mask'
import { getCEP } from '@/service/cep'

const props = {
  form: {
    type: Object,
    require: true,
  },
  validate: {
    type: Boolean,
    default: false,
  },
}

export default {
  props,
  directives: { mask },
  data() {
    return {
      searchingCEP: false,
      cepNotFoundMessage: '',
    }
  },
  computed: {
    ...mapGetters({
      resources: 'resources',
    }),

    labels: function() {
      return Object.assign({}, this.resources.page.home.address)
    },
  },
  methods: {
    async searchCEP(cep) {
      if (cep.length !== 9) return undefined
      this.searchingCEP = true
      const info = await getCEP(cep)
      this.searchingCEP = false

      this.cepNotFoundMessage = info.erro ? this.labels.invalidCEP : ''

      Object.assign(this.form, {
        address: info.logradouro,
        state: info.localidade,
        city: info.uf,
      })
    },

    validateField(field) {
      if (!this.validate) return undefined

      return !!this.form[field].length
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~@/styles/custom/colors';

.custom-input-label.text-red02 {
  color: map-get($theme-colors, 'red02');
}

.fix-padding {
  padding: 0.375rem 0.75rem !important;
}
</style>
